import React from 'react';
import { FadeLoader } from 'react-spinners';
import ReactPaginate from 'react-paginate';

const renderTable = ({ data }, validate) => {
  if (data.length) {
    return data.map(cliente => (
      <tr key={cliente.codigo}>
        <td>{cliente.codigo}</td>
        <td>{cliente.nombre}</td>
        <td>{cliente.ruc}</td>
        <td>{cliente.dni}</td>
        <td onClick={() => validate(cliente)} />
      </tr>
    ));
  }
  return <tr><td className='no-before' colSpan={5}>No hay resultados</td></tr>;
};

const TablaCliente = props => (
  <div>
    <div className='tableWrapper hide-scroll'>
      <table className='table table-hover table-link'>
        <thead className='table-head'>
          <tr>
            <th>Código</th>
            <th>Nombre</th>
            <th>RUC</th>
            <th>DNI</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {
            props.clientes
             ? renderTable(props.clientes, props.showClientProform)
             : <tr><td className='no-before' colSpan={5}><FadeLoader color={'#F8A14A'} loading /></td></tr>
          }
        </tbody>
      </table>
    </div>
    {
      props.clientes &&
      <div className={props.clientes.numerodePaginas > 1 ? 'paginationWrapper' : 'hidden'}>
        <div className='row' style={{ marginTop: '20px' }}>
          <div className='col-sm-6 pull-right'>
            <ReactPaginate
              pageCount={props.clientes.numerodePaginas}
              onPageChange={props.paginateClient}
              previousLabel='<<'
              nextLabel='>>'
              containerClassName='pagination pull-right'
              pageClassName='pagination-item'
              activeClassName='pagination-item--active'
              pageLinkClassName='btn-clean pagination-item-btn'
              breakClassName='break pagination-item'
            />
          </div>
        </div>
      </div>
    }

  </div>
);

export default TablaCliente;



// WEBPACK FOOTER //
// ./src/pages/modals/CambiarCliente/TablaCliente.js